define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupsGridEmptyView.tmpl");

    var AgentGroupsGridEmptyView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsGridEmptyView = Marionette.ItemView.extend({
            template: template,
            className: "empty-tbl"
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsGridEmptyView;
});